module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-murale-edge.64429a23.jpg";